import {
  Box,
  Divider,
  Heading,
  ListItem,
  OrderedList,
  Text,
  useColorModeValue,
} from "@chakra-ui/react"
import { createFileRoute } from "@tanstack/react-router"
import { WmsPageHeader } from "../../../../components/WMS/shared/WmsPageHeader"
import {
  WmsPagePanel,
  WmsPageShell,
} from "../../../../components/WMS/shared/WmsPageShell"

export const Route = createFileRoute(
  "/_layout/WMS/inventory-count/instructions-worker",
)({
  component: InventoryCountWorkerInstructionsPage,
})

function InventoryCountWorkerInstructionsPage() {
  const panelBg = useColorModeValue("white", "gray.800")
  const panelBorder = useColorModeValue("gray.200", "whiteAlpha.200")
  const mutedText = useColorModeValue("gray.600", "gray.300")

  return (
    <WmsPageShell>
      <WmsPageHeader
        title="Instrukcja: Pracownik weryfikacji"
        description="Krok po kroku: proces weryfikacji, podejmowanie decyzji oraz kontrola wyników inwentaryzacji."
        gradient="linear(to-r, blue.600, cyan.600)"
        badge="Weryfikacja"
      />

      <WmsPagePanel bg={panelBg} borderColor={panelBorder}>
        <Box flex="1" minH={0} overflowY="auto" pr={1}>
          <Box>
            <Heading size="sm" mb={3}>
              Praca z kolejką weryfikacji
            </Heading>
            <OrderedList spacing={2} pl={5}>
              <ListItem>Otwórz: /WMS/inventory-count/review.</ListItem>
              <ListItem>
                Zastosuj filtry: magazyn, wykonawca, wiek zadania, «tylko z
                odchyleniem».
              </ListItem>
              <ListItem>
                Otwórz szczegóły zadania za pomocą przycisku «Otwórz szczegóły».
              </ListItem>
            </OrderedList>
          </Box>

          <Divider my={5} />

          <Box>
            <Heading size="sm" mb={3}>
              Decyzje dotyczące zadania
            </Heading>
            <OrderedList spacing={2} pl={5}>
              <ListItem>
                «Zatwierdź»: zadanie przechodzi w status «approved».
              </ListItem>
              <ListItem>
                «Przelicz»: zadanie przechodzi w status «in_progress», tworzona
                jest nowa runda liczenia.
              </ListItem>
              <ListItem>
                «Odrzuć»: zadanie przechodzi w status «cancelled».
              </ListItem>
              <ListItem>
                Dla opcji «Przelicz» i «Odrzuć» obowiązkowo podaj przyczynę.
              </ListItem>
            </OrderedList>
          </Box>

          <Divider my={5} />

          <Box>
            <Heading size="sm" mb={3}>
              Księgowanie (posting)
            </Heading>
            <OrderedList spacing={2} pl={5}>
              <ListItem>
                Dla zatwierdzonego zadania wykonaj księgowanie w swoim procesie
                roboczym.
              </ListItem>
              <ListItem>
                Po zaksięgowaniu status powinien zmienić się na «posted».
              </ListItem>
              <ListItem>
                Sprawdź, czy korekty zapasów zostały uwzględnione w ruchach
                magazynowych.
              </ListItem>
            </OrderedList>
          </Box>

          <Divider my={5} />

          <Box>
            <Heading size="sm" mb={3}>
              Codzienna kontrola
            </Heading>
            <OrderedList spacing={2} pl={5}>
              <ListItem>
                Pulpit nawigacyjny KPI: /WMS/inventory-count/dashboard.
              </ListItem>
              <ListItem>
                Anomalie i drill-down: /WMS/reports/inventory-count-alerts.
              </ListItem>
              <ListItem>
                Kontroluj starzenie się zadań w statusie pending_review, ponowne
                przeliczenia (recount) oraz nagłe wzrosty liczby korekt.
              </ListItem>
            </OrderedList>
          </Box>

          <Divider my={5} />

          <Box>
            <Heading size="sm" mb={3}>
              Jeśli wystąpi problem
            </Heading>
            <OrderedList spacing={2} pl={5}>
              <ListItem>
                403 insufficient permissions: skontaktuj się z administratorem w
                celu uzyskania uprawnień do wms.inventory_count.task.approve /
                recount / post.
              </ListItem>
              <ListItem>
                Jeśli zadanie nie przechodzi w status «approved»: sprawdź
                przyczynę w odpowiedzi API oraz historię decyzji.
              </ListItem>
            </OrderedList>
          </Box>

          <Text fontSize="sm" color={mutedText} mt={6}>
            Szybkie skróty: /WMS/inventory-count/review,
            /WMS/inventory-count/dashboard
          </Text>
        </Box>
      </WmsPagePanel>
    </WmsPageShell>
  )
}
